import * as React from 'react';
import cn from 'classnames';
import { SizeType, intentClass, ControlShapeType, Enum } from '../../../library';
import { IconClose } from '../.././../icons';
export var CloseAppearanceType = Enum({
  FILL: 'fill',
  MINIMAL: 'minimal'
});
export var Close = function Close(props) {
  var classNames = cn('close', {
    '-sm': props.size === SizeType.SMALL,
    '-lg': props.size === SizeType.LARGE
  }, "-".concat(props.shape), "-".concat(props.appearance), intentClass(props.intent), props.className);
  return React.createElement("button", {
    type: "button",
    className: classNames,
    onClick: props.onClick,
    onFocus: props.onFocus,
    onBlur: props.onBlur,
    "aria-label": "Close"
  }, React.createElement(IconClose, null));
};
Close.displayName = 'Close';
Close.defaultProps = {
  size: SizeType.MEDIUM,
  shape: ControlShapeType.CIRCULAR,
  appearance: CloseAppearanceType.MINIMAL
};